export default __webpack_public_path__ + "static/media/p3.aaa17baa.svg";